import classNames from 'classnames'

import type { ReactElement } from 'react'
import type { IBlockProps } from '~/types/template'

import './styles.scss'

const ButtonBlock = ({ className, color, onClick }: IBlockProps): ReactElement => {
  const classes = classNames('block button-block', className)

  return (
    <div className={classes} onClick={onClick}>
      <div className="button-block__button" style={{ backgroundColor: color }} />
    </div>
  )
}

export default ButtonBlock
